export enum TrackingConsentStatus {
  AUTHORIZED = 'authorized',
  DENIED = 'denied',
  // Used for implementing consent mode (these pixels need to load but not send data,
  // using DENIED status would not load the pixels at all)
  DECLINED = 'declined', // User has rejected cookies in the consent banner
  NOT_DETERMINED = 'notDetermined',
}
